import { Chip, Box } from "@mui/material";

import { ListItem } from "./styles";

interface PaymentStatusFilterProps {
    value: string;
    onChange: (status: string) => void;
}

export function PaymentStatusFilter({
    value,
    onChange,
}: PaymentStatusFilterProps) {
    const chipData: { key: string; label: string }[] = [
        { key: "", label: "Todos" },
        { key: "paid", label: "Pago" },
        { key: "pending", label: "Pendente" },
        { key: "cancelled", label: "Cancelado" },
        { key: "refunded", label: "Reembolsado" },
        { key: "denied", label: "Negado" },
    ];

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
            }}
            component="ul"
        >
            {chipData.map((data) => {
                return (
                    <ListItem key={data.key}>
                        <Chip
                            size="small"
                            label={data.label}
                            color={value === data.key ? "primary" : "default"}
                            onClick={() => onChange(data.key)}
                            sx={{ borderRadius: 2 }}
                        />
                    </ListItem>
                );
            })}
        </Box>
    );
}
